import React, { forwardRef } from "react";

const Checkbox = forwardRef((props, ref) => {
  const { checked, indeterminate, onChange, disabled, color = "primary", className = "", ...rest } = props;

  const activeColor = color === "secondary" ? "accent-purple-600" : "accent-[var(--primaryColor)]";

  return (
    <input
      ref={(node) => {
        if (node) node.indeterminate = !!indeterminate;
        if (typeof ref === "function") ref(node);
        else if (ref) ref.current = node;
      }}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={`h-4 w-4 rounded border-farmazon-border ${activeColor} ${className}`}
      {...rest}
    />
  );
});

Checkbox.displayName = "Checkbox";

export default Checkbox;
